<template>
  <div class="grid">
    <div :class=" ( !isLoading) ? 'grid-body pb-0' : 'grid-body'">
      <v-row align="center" class="p-3">
        <v-col cols="7">
          <v-text-field
            v-model="paging.name"
            v-on:keyup="search()"
            :label="$t('_LIST_GROUP.SEARCH_PLACEHOLDER')"
            class="mt-0 pt-0"
          ></v-text-field>
        </v-col>
        <v-col cols="5" class="text-right">
          <v-btn @click="addGroup" color="primary" class="pr-10 pl-10">
            <v-icon dark>
              mdi-plus
            </v-icon>
            {{$t('ADD_NEW')}}
          </v-btn>
        </v-col>
      </v-row>

      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>

      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="15"
        disable-sort
        hide-default-footer
        item-key="id"
        class="table-user"
      >
        <template slot="no-data">
          <span>{{$t("HAS_NO_DATA")}}</span>
        </template>
        <template v-slot:item.description="{ item }">
          <span style="white-space: pre-wrap">{{item.description}}</span>
        </template>
        <template v-slot:item.groupName="{ item }">
          <span style="font-weight: 500;">{{item.groupName}}</span>
        </template>
        <template v-slot:item.createdDate="{ item }">
          <span>{{formatDateTime(item.createdDate, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm')}}</span>
        </template>
        <template v-slot:item.active="{ item }">
          <span
            v-if="!item.active"
            class="status-deactived not-active"
          >{{$t('_LIST_GROUP.STATUS_DEACTIVATE')}}</span>
          <span
            v-if="item.active"
            class="status-actived active"
          >{{$t('_LIST_GROUP.STATUS_ACTIVATE')}}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip top transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                @click="editGroup(item)"
                x-small
                class="rounded-sm mr-1"
                v-bind="attrs"
                v-on="on"
                color="accent"
              >
                <v-icon size="15">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            {{ $t("EDIT") }}
          </v-tooltip>
          <v-tooltip top transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="error"
                @click="openDialogDeleteGroup(item)"
                x-small
                v-bind="attrs"
                v-on="on"
                class="rounded-sm"
              >
                <v-icon size="15">
                  delete
                </v-icon>
              </v-btn>
            </template>
            {{ $t("DELETE") }}
          </v-tooltip>
        </template>
      </v-data-table>
   
      <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage" class="pr-3">
        <span slot="totalItems">{{$t("TOTAL")}}: {{paging.total}} {{$t("_LIST_GROUP.GROUP")}}</span>
      </paging>

      <!-- Delete group dialog -->
      <v-dialog v-model="deleteGroupDialog" max-width="260" content-class="dialog-confirm">
        <v-toolbar class="toolbar-update" dense >
          <v-toolbar-title class="text-primary fs-15">
            <strong>{{$t('NOTIFICATION')}}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <div class="content-update">
          <label class="s-label">
            {{ $t('_LIST_GROUP.REMOVE') }}
          </label>
          <div class="mt-3 d-flex justify-content-between">
            <div class="w-100 mr-1">
              <v-btn depressed block @click="deleteGroupDialog = false">
                {{ $t("_LOGIN.CANCEL") }}
              </v-btn>
            </div>
            <div class="w-100 ml-1">
              <v-btn block color="error" @click="deleteGroup">
                {{ $t("DELETE") }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-header {
  background-color: #fff;
  padding: 25px 15px;
}
</style>

<script>
import Input from "@/components/Utils/Input.vue";
import Paging from "@/components/Utils/Paging.vue";
import { LIMIT_AND_OFFSET } from "@/_helpers/config.js";
import { _alert, _formatDateTime } from "@/_helpers/function.js";
import { service } from "@/_services/Account/ManageUser/manage-user.service.js";
import debounce from "lodash.debounce";

export default {
  components: {
    "input-text": Input,
    paging: Paging
  },
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: this.$t("_LIST_GROUP.GROUP_NAME"),
          align: "left",
          value: "groupName",
          width: "15%"
        },
        {
          text: this.$t("_LIST_GROUP.DESCRIPTION"),
          align: "left",
          value: "description"
        },
        {
          text: this.$t("_LIST_GROUP.CREATE_USER"),
          align: "left",
          value: "createdBy",
          width: "12%"
        },
        {
          text: this.$t("_LIST_GROUP.CREATE_DATE"),
          align: "left",
          value: "createdDate",
          width: "16%"
        },
        {
          text: this.$t("_LIST_GROUP.STATUS"),
          align: "left",
          value: "active",
          width: "16%"
        },
        {
          text: this.$t("_LIST_GROUP.ACTION"),
          align: "center",
          value: "action",
          width: "10%"
        }
      ],
      data: [],
      paging: {
        // total: 0,
        limit: 15,
        offset: 0,
        name: ""
      },
      currentGroup: null,
      deleteGroupDialog: false
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    search: debounce(function(value) {
      this.getAll();
    }, 300),
    formatDateTime(value, inputFormat, outputFormat) {
      return _formatDateTime(value, inputFormat, outputFormat);
    },
    // Run when start
    initialize() {
      // Call service
      this.getAll();
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    // Get all user group
    getAll() {
      this.isLoading = true;
      delete this.paging.total;
      service
        .getAllUserGroup(this.paging)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data;
          }
        })
        .finally(() => (this.isLoading = false));
    },
    addGroup() {
      this.$router.push({ name: "addGroup" });
    },
    editGroup(item) {
      this.$router.push({ name: "editGroup", params: { id: item.id } });
    },
    openDialogDeleteGroup(item) {
      this.deleteGroupDialog = true;
      this.currentGroup = item;
    },
    deleteGroup() {
      this.deleteGroupDialog = false;
      if (!this.currentGroup) {
        return;
      }
      this.isLoading = true;
      service
        .deleteUserGroup(this.currentGroup.id)
        .then(res => {
          if (res.responseCode === 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>